import { render, staticRenderFns } from "./AttrAddForm.vue?vue&type=template&id=be4d22b0&"
import script from "./AttrAddForm.vue?vue&type=script&lang=js&"
export * from "./AttrAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports